module.exports = "/images/icon-doc.svg?9872354fd98e0539b2522143de53ec00";